<template>
  <div class="container-help" :style="`paddingTop:${barHeight}px`">
    <van-nav-bar class="van-bar" title="" left-arrow @click-left="closeWeb">
      <template #left>
        <img class="left-nav" src="@/assets/packageAssets/common/arrow05.png" alt="" @click-left="closeWeb" />
      </template>
    </van-nav-bar>
    <div class="main">
      <div class="title">{{ $t('lang.faq.faq') }}</div>
      <div class="head">{{ $t('lang.faq.introduction') }}</div>
      <!-- goparty ios -->
      <div v-if="this.appNameFlag('goparty', this.appName)">
        <div class="tit" id="tit1">1.{{ $t('lang.faq.tit1') }}</div>
        <div>{{ $t('lang.faq.content1') }}</div>
        <div class="tit" id="tit2">2.{{ $t('lang.faq.tit2') }}</div>
        <div>{{ $t('lang.faq.content2') }}</div>
        <div class="tit" id="tit6">3.{{ $t('lang.faq.tit6') }}</div>
        <div>{{ $t('lang.faq.content6') }}</div>
        <div class="tit" id="tit7">4.{{ $t('lang.faq.tit7') }}</div>
        <div>{{ $t('lang.faq.content7') }}</div>
        <div class="tit" id="tit8">5.{{ $t('lang.faq.tit8') }}</div>
        <div>{{ $t('lang.faq.content8') }}</div>
        <div class="tit" id="tit9">6.{{ $t('lang.faq.tit9') }}</div>
        <div>{{ $t('lang.faq.content9') }}</div>
        <div class="tit" id="tit10">7.{{ $t('lang.faq.tit10') }}</div>
        <div>{{ $t('lang.faq.content10') }}</div>
      </div>
      <!-- joylink ios 过包 -->
      <div v-if="this.domainNameFlag('joylink', this.domain)">
        <div class="tit" id="tit1">1.{{ $t('lang.jLink.tit1') }}</div>
        <div>{{ $t('lang.jLink.content1') }}</div>
        <div class="tit" id="tit2">2.{{ $t('lang.jLink.tit2') }}</div>
        <div v-html="$t('lang.jLink.content2')"></div>
        <div class="tit" id="tit3">3.{{ $t('lang.jLink.tit3') }}</div>
        <div>{{ $t('lang.jLink.content3') }}</div>
        <div class="tit" id="tit4">4.{{ $t('lang.jLink.tit4') }}</div>
        <div v-html="$t('lang.jLink.content4')"></div>
        <div class="tit" id="tit5">5.{{ $t('lang.jLink.tit5') }}</div>
        <div>{{ $t('lang.jLink.content5') }}</div>
      </div>
      <div v-if="this.domainNameFlag('vava', this.domain) || this.domainNameFlag('joychat', this.domain)">
        <!-- 渠道是vvg  是vava的 -->
        <!-- 分男女 -->
        <div v-if="gender == 1">
          <div class="tit" id="tit1">1.{{ $t('lang.faq.tit1') }}</div>
          <div>{{ $t('lang.faq.content1') }}</div>
          <div class="tit" id="tit2">2.{{ $t('lang.faq.tit2') }}</div>
          <div>{{ $t('lang.faq.content2') }}</div>
          <div class="tit" id="tit3">3.{{ $t('lang.faq.tit3') }}</div>
          <div>{{ $t('lang.faq.content3') }}</div>
          <div class="tit" id="tit4">4.{{ $t('lang.faq.tit4') }}</div>
          <div>{{ $t('lang.faq.content4') }}</div>
          <div class="tit" id="tit5">5.{{ $t('lang.faq.tit5') }}</div>
          <div>{{ $t('lang.faq.content5') }}</div>
          <div class="tit" id="tit6">6.{{ $t('lang.faq.tit6') }}</div>
          <div>{{ $t('lang.faq.content6') }}</div>
          <div class="tit" id="tit7">7.{{ $t('lang.faq.tit7') }}</div>
          <div>{{ $t('lang.faq.content7') }}</div>
          <div class="tit" id="tit8">8.{{ $t('lang.faq.tit8') }}</div>
          <div>{{ $t('lang.faq.content8') }}</div>
          <div class="tit" id="tit9">9.{{ $t('lang.faq.tit9') }}</div>
          <div>{{ $t('lang.faq.content9') }}</div>
          <div class="tit" id="tit10">10.{{ $t('lang.faq.tit10') }}</div>
          <div>{{ $t('lang.faq.content10') }}</div>
          <div class="tit" id="tit11">11.{{ $t('lang.faq.tit11') }}</div>
          <div>{{ $t('lang.faq.content11') }}</div>
        </div>
        <div v-else>
          <!-- 女的 -->
          <div class="tit" id="tit1">1.{{ $t('lang.faqF.tit1') }}</div>
          <div>{{ $t('lang.faqF.content11') }}</div>
          <div>{{ $t('lang.faqF.content12') }}</div>
          <div>{{ $t('lang.faqF.content13') }}</div>
          <div>{{ $t('lang.faqF.content14') }}</div>
          <div>{{ $t('lang.faqF.content15') }}</div>
          <div>{{ $t('lang.faqF.content16') }}</div>
          <div class="tit" id="tit2">2.{{ $t('lang.faqF.tit2') }}</div>
          <div>{{ $t('lang.faqF.content21') }}</div>
          <div>{{ $t('lang.faqF.content22') }}</div>
          <div>{{ $t('lang.faqF.content23') }}</div>
          <div>{{ $t('lang.faqF.content24') }}</div>
          <div>{{ $t('lang.faqF.content25') }}</div>
          <div>{{ $t('lang.faqF.content26') }}</div>
          <div>{{ $t('lang.faqF.content27') }}</div>
          <div class="tit" id="tit3">3.{{ $t('lang.faqF.tit3') }}</div>
          <div>{{ $t('lang.faqF.content31') }}</div>
          <div>{{ $t('lang.faqF.content32') }}</div>
          <div>{{ $t('lang.faqF.content36') }}</div>
          <div>{{ $t('lang.faqF.content37') }}</div>
          <div>{{ $t('lang.faqF.content38') }}</div>
          <div>{{ $t('lang.faqF.content39') }}</div>
          <div>{{ $t('lang.faqF.content40') }}</div>
          <div class="tit" id="tit4">4.{{ $t('lang.faqF.tit4') }}</div>
          <div>{{ $t('lang.faqF.content41') }}</div>
          <div>{{ $t('lang.faqF.content42') }}</div>
          <div class="tit" id="tit5">5.{{ $t('lang.faqF.tit5') }}</div>
          <div>{{ $t('lang.faqF.content51') }}</div>
          <div>{{ $t('lang.faqF.content52') }}</div>
          <div>{{ $t('lang.faqF.content53') }}</div>
          <div>{{ $t('lang.faqF.content54') }}</div>
          <div>{{ $t('lang.faqF.content55') }}</div>
          <div class="tit" id="tit6">6.{{ $t('lang.faqF.tit6') }}</div>
          <div>{{ $t('lang.faqF.content61') }}</div>
          <div class="tit" id="tit7">7.{{ $t('lang.faqF.tit7') }}</div>
          <div>{{ $t('lang.faqF.content71') }}</div>
          <div>{{ $t('lang.faqF.content72') }}</div>
          <div>{{ $t('lang.faqF.content73') }}</div>
          <div class="tit" id="tit8">8.{{ $t('lang.faqF.tit8') }}</div>
          <div>{{ $t('lang.faqF.content80') }}</div>
          <div>{{ $t('lang.faqF.content81') }}</div>
          <div>{{ $t('lang.faqF.content82') }}</div>
          <div>{{ $t('lang.faqF.content83') }}</div>
          <div>{{ $t('lang.faqF.content84') }}</div>
          <div>{{ $t('lang.faqF.content85') }}</div>
          <div>{{ $t('lang.faqF.content86') }}</div>
          <div>{{ $t('lang.faqF.content87') }}</div>
          <div class="tit" id="tit9">9.{{ $t('lang.faqF.tit9') }}</div>
          <div>{{ $t('lang.faqF.content90') }}</div>
          <div>{{ $t('lang.faqF.content91') }}</div>
          <div>{{ $t('lang.faqF.content92') }}</div>
          <div>{{ $t('lang.faqF.content93') }}</div>
          <div class="tit" id="tit10">10.{{ $t('lang.faqF.tit10') }}</div>
          <div>{{ $t('lang.faqF.content100') }}</div>
          <div>{{ $t('lang.faqF.content101') }}</div>
          <div>{{ $t('lang.faqF.content102') }}</div>
        </div>
      </div>
      <!-- 这是树洞echo的faq -->
      <div v-if="this.domainNameFlag('echo', this.domain)">
        <div class="tit" id="tit1">{{ $t('lang.echo.tit1') }}</div>
        <div>{{ $t('lang.echo.content1') }}</div>
        <div class="tit" id="tit2">{{ $t('lang.echo.tit2') }}</div>
        <div>{{ $t('lang.echo.content2') }}</div>
        <div class="tit" id="tit3">{{ $t('lang.echo.tit3') }}</div>
        <div>{{ $t('lang.echo.content3') }}</div>
        <div class="tit" id="tit4">{{ $t('lang.echo.tit4') }}</div>
        <div>{{ $t('lang.echo.content4') }}</div>
        <div class="tit" id="tit5">{{ $t('lang.echo.tit5') }}</div>
        <div>{{ $t('lang.echo.content5') }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import Client from '@/assets/scripts/client'

export default {
  data() {
    let query = this.$route.query
    return {
      id: query.id || null,
      barHeight: query.statusBarHeight || 38,
      channel: '',
      gender: '',
      appName: '',
      domain: window.location.hostname || 'localhost'
    }
  },
  methods: {
    getInfo() {
      const AppInfo = Client.getAppInfo()
      this.appName = AppInfo.appPackageName
      // 获取不到就是男用户的fqa 返回值为1=男用户，2=女用户
      this.gender = AppInfo.gender || 1
    }
  },
  mounted() {
    this.getInfo()
  }
}
</script>
<style lang="scss" scoped>
.container-help {
  width: 100%;
  min-height: 100vh;
  background: #ffffff;
  .main {
    padding: 0 16px 16px 16px;
    color: #666666;
    line-height: 20px;
    font-size: 13px;
    .title {
      width: 100%;
      margin-bottom: 16px;
      text-align: center;
      font-size: 16px;
      color: #333;
      font-weight: bold;
    }
    .head {
      text-indent: 2em;
    }
    .tit {
      font-weight: 700;
      color: #333333;
      margin: 16px 0 8px 0;
      font-size: 14px;
    }
    ::v-deep b {
      color: #4188f1 !important;
    }
  }
}
</style>
